import { render, staticRenderFns } from "./uiDownload.vue?vue&type=template&id=73b63b24&scoped=true&"
import script from "./uiDownload.vue?vue&type=script&lang=js&"
export * from "./uiDownload.vue?vue&type=script&lang=js&"
import style0 from "./uiDownload.vue?vue&type=style&index=0&id=73b63b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b63b24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
